import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { B2B_PACKAGE_TYPE, C2C_PACKAGE_TYPE, DOCUMENTS_PACKAGE_TYPE, STANDARD_PACKAGE_TYPE } from "../../data/static-data";
import { isB2BPackage, isC2CPackage, isDocumentsPackage, isStandardPackage } from "../../helpers/packageTypesHelper/packageTypesHelper";

const Upper = ({ state, setState }) => {
    const {t} = useTranslation()
    useEffect(() => {
        if(state["package-type"])
            return;

        setState((prev) => ({
            ...prev,
            "package-type": STANDARD_PACKAGE_TYPE,
        }));
    }, [setState, state]);
    return (
        <>
            <div className="text-xl sm:text-3xl font-extralight mb-4">
                {t("calculator.header")}
            </div>
            <div className="flex flex-col gap-1">
                <div className="font-extralight text-left text-3xs xs:text-xs sm:text-sm">
                    {t("calculator.package_type.title")}
                </div>
                <label className="font-light text-left">
                    <input 
                      checked={isStandardPackage(state["package-type"])}
                      type="radio" 
                      value={STANDARD_PACKAGE_TYPE}
                      onChange={(e) => setState((prev) => ({ ...prev, "package-type": e.target.value }))}
                    />
                    <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                        {t("calculator.package_type.values.standard")}
                    </span>
                </label>
                <label className="font-light text-left">
                    <input 
                      checked={isDocumentsPackage(state["package-type"])}
                      type="radio" 
                      value={DOCUMENTS_PACKAGE_TYPE}
                      onChange={(e) => setState((prev) => ({ ...prev, "package-type": e.target.value }))}
                    />
                    <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                        {t("calculator.package_type.values.documents")}
                    </span>
                </label>
                <label className="font-light text-left">
                    <input 
                      checked={isB2BPackage(state["package-type"])}
                      type="radio" 
                      value={B2B_PACKAGE_TYPE}
                      onChange={(e) => setState((prev) => ({ ...prev, "package-type": e.target.value }))}
                    />
                    <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                        {t("calculator.package_type.values.B2B")}
                    </span>
                </label>
                <label className="font-light text-left">
                    <input 
                      checked={isC2CPackage(state["package-type"])}
                      type="radio" 
                      value={C2C_PACKAGE_TYPE}
                      onChange={(e) => setState((prev) => ({ ...prev, "package-type": e.target.value }))}
                    />
                    <span className="ml-3 text-2xs xs:text-xs sm:text-sm">
                        {t("calculator.package_type.values.C2C")}
                    </span>
                </label>
            </div>
        </>
    );
};

export default Upper;
